<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div class="dialog__body__order-cancel-confirm">
    <p *ngIf="messages.length===1">{{messages[0]}}</p>
    <p *ngIf="messages.length===1 && subMessage!==null">{{subMessage}}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionConfirmed()"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
